(function() {
    'use strict';

    angular.module('allegro').controller('AllegroSenderUpdateController', AllegroSenderUpdateController);

    AllegroSenderUpdateController.$inject = [
        '$state',
        '$stateParams',
        'notificationSrvc',
        'errorNotificationSrvc',
        'allegroAccountDataSrvc',
        'allegroSendersDataSrvc',
        'allegroSenderMessagesConst'
    ];

    function AllegroSenderUpdateController(
        $state,
        $stateParams,
        notificationSrvc,
        errorNotificationSrvc,
        allegroAccountDataSrvc,
        allegroSendersDataSrvc,
        allegroSenderMessagesConst
    ){
        var self = this;
        self.loading = false;

        self.serverErrors = {
            account: [],
            tax_id: [],
            company_name: [],
            name: [],
            street: [],
            zip_code: [],
            city: [],
            country_code: [],
            email: [],
            phone: []
        };

        self.account = {};
        self.senderData = {
            account: null,
            company_name: '',
            name: '',
            street: '',
            zip_code: '',
            city: '',
            country_code: '',
            email: '',
            phone: '',
        };

        self.getAccount = getAccount;
        self.getSenderData = getSenderData;
        self.updateSender = updateSender;
        self.cleanErrors = cleanErrors;

        active();

        function active(){
            self.loading = true;

            self.getSenderData($stateParams.pk)
                .then(function(response) {
                    if (response.account) {
                        return self.getAccount(response.account);
                    }
                })
                .then(function(data) {
                    self.loading = false;
                });
        }

        function getAccount(accountPk) {
            return allegroAccountDataSrvc.get({pk: accountPk})
                .$promise
                .then(function (response) {
                    self.account = response;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function () {});
        }

        function getSenderData(sellerPk){
            return allegroSendersDataSrvc.get({pk: sellerPk})
                .$promise
                .then(function (response) {
                    self.senderData = response;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function updateSender() {
            allegroSendersDataSrvc.update({pk: self.senderData.pk}, self.senderData)
                .$promise
                .then(function(response) {
                    notificationSrvc.notification("success", allegroSenderMessagesConst.update);
                    $state.go('layout.allegro-accounts.detail.settings', {pk: self.account.pk});
                })
                .catch(function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
